@if (hostRenderer(); as renderer) {
<ng-container *ngComponentOutlet="renderer; inputs: hostInputs()"></ng-container>
} @else {
<p-ai-chat-generic-entity-renderer [display]="display()"></p-ai-chat-generic-entity-renderer>
}
